import client from './client';
import qs from 'qs';

const approvalUrl = '/api/v1/common/approval';
const orderUrl = '/api/v1/project/orders';
const techUrl = '/api/v1/project/tech';
const taxUrl = '/api/v1/project/invoice';

//결재history
export const getApprovalHistory = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${approvalUrl}/history?${queryString}`);
};
// /history/{historyTyp} 2023.10.05
//
// 2026-10-20 수정(업무 흐름 점검 이슈 #8): 호출부(listApprovals 액션)가 넘기는 payload는
// { type, searchData }이고 searchData는 이미 평평한 검색조건 객체(searchStatus/strtDt/...)
// 인데, 여기서 "searchData.searchData"(한 겹 더 들어간 존재하지 않는 키)를 직렬화하고
// 있어서 항상 undefined → 빈 쿼리스트링이 나갔다. 그 결과 "결재완료"/"결재반려" 칩을
// 눌러도, 날짜 범위를 입력해도 서버에 전혀 전달되지 않아 화면이 바뀌지 않는 것처럼
// 보였다(검색조건 전체가 무시됨). searchData를 그대로 직렬화하도록 수정.
export const getApprovalHistoryByType = ({ type, searchData }) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${approvalUrl}/history/${type}?${queryString}`);
};

export const getApprovalMonitor = (searchData) => {
  // 이 함수는 호출부(listApprovalMonitor)가 { searchData } 형태로 한 번 감싸서 넘기므로
  // (action 정의: (searchData) => ({ searchData })), 여기서는 그대로 풀어야 한다 —
  // getApprovalHistoryByType과 달리 이 쪽은 원래도 맞았다.
  const queryString = qs.stringify(searchData.searchData);
  return client.get(`${approvalUrl}/now/all?${queryString}`);
};

//DOCU_CD의 현재 결재Doc 정보
export const getCurApprovalDetByCd = (id) => {
  return client.get(`${approvalUrl}/info/${id}`);
};

//결재정보 상세
export const getApproval = (id) => {
  return client.get(`${approvalUrl}/list/${id}`);
};

// 결재 삭제
export const deleteApproval = (id) => {
  return client.delete(`${approvalUrl}/info/${id}`);
};

//결재정보
export const addOrderDoc = (dataToSubmit) => {
  return client.post(
    `${orderUrl}/data/${dataToSubmit.docuCd}/approval/${dataToSubmit.docuUuid}`,
    dataToSubmit,
  );
};

export const addTechDoc = (dataToSubmit) => {
  return client.post(
    `${techUrl}/rslt/data/${dataToSubmit.docuCd}/approval/${dataToSubmit.docuUuid}`,
    dataToSubmit,
  );
};

//세금계산서
export const addTaxDoc = (dataToSubmit) => {
  return client.post(
    `${taxUrl}/issue/${dataToSubmit.docuCd}/approval/${dataToSubmit.docuUuid}`,
    dataToSubmit,
  );
};
